// extracted by mini-css-extract-plugin
module.exports = {"container":"priceTable_container__D9PO0","table":"priceTable_table__d19OL","row":"priceTable_row__OBDFa","header":"priceTable_header__zdB1T"};